module.exports = __webpack_public_path__ + "img/Partner_UPay.13f232c9.svg";